export default theme => ({
  root: {
    position: 'absolute',
    top: 340,
    right: 30
  },

  root2: {
    position: 'absolute',
    bottom: -100,
    left: 10,
  },

  originTopLeft: {
    top: '20%',
    transform: 'scale(1) translate(-145%, 0%)',
    transformOrigin: '0% 0%',
  },

  originTopRight: {
    top: '20%',
    transform: 'scale(1) translate(145%, 0%)',
    transformOrigin: '100% 0%',
  },

  originBottomLeft: {
    bottom: 0,
    transform: 'scale(1) translate(-145%, 0%)',
    transformOrigin: '0% 100%',
  },

  originBottomRight: {
    bottom: 0,
    transform: 'scale(1) translate(145%, 0%)',
    transformOrigin: '100% 100%',
  },

  icon: {
    fontSize: theme.typography.pxToRem(240),
    color: '#f6f6f6',
  }
})